<script lang="ts" setup>
import ImageMap from 'image-map'

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  mapName: {
    type: String,
    required: true,
  },
})

const handleLoadImage = () => {
  ImageMap(`img[usemap="${props.mapName}"]`)
}
</script>

<template>
  <div class="ImageMapper">
    <img
      :src="src"
      :usemap="mapName"
      class="ImageMapper__image"
      @load="handleLoadImage"
    />
    <slot name="default"></slot>
  </div>
</template>

<style lang="scss" scoped>
.ImageMapper {
  &__image {
    width: 100%;
  }
  &:deep(area) {
    cursor: pointer;
  }
}
</style>
